import { datadogRum } from '@datadog/browser-rum';
import { AppConfig } from '@chr/online-shared-microsite-core';

export async function initializeDataDog(config: AppConfig) {
  const environment = config.environment;
  if (environment && environment !== 'local') {
    datadogRum.init({
      applicationId: 'bc160d93-5b4f-44bd-9453-3e18dd993681',
      clientToken: 'pub1a40b2d850bedeeddbd83c9106359cfe',
      site: 'us3.datadoghq.com',
      service: config.name,
      env: environment,
      version: '1.0.0',
      sessionSampleRate: 50,
      sessionReplaySampleRate: 10,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
      useSecureSessionCookie: true,
      allowedTracingUrls: [{
        match: /https:\/\/.*\.chrobinson\.com/,
        propagatorTypes: ['datadog']
      }],

      beforeSend: event => {
        event.view.url = event.view.url.toLowerCase().replace('#/', '');
        return true;
      },
    });

    datadogRum.startSessionReplayRecording();
  }
}
